import React from "react";
import { FieldValues } from "react-hook-form";

import FormGenerator from "../../form/FormGenerator";
import { FormFieldType, FormFieldTypesAllowed } from "../../../types/form/form-types";
import { scheduledReportsApi, ScheduledReportTemplateData } from "../../api/scheduled-reports/scheduled-report.service";

const { useGetReportTypesQuery } = scheduledReportsApi;

interface Props {
  defaultValues: FieldValues;
  handleSubmit: (form_values: ScheduledReportTemplateData) => void;
  loading?: boolean;
}
const ScheduledReportsTemplatesForm: React.FC<Props> = ({ defaultValues, handleSubmit, loading = false }) => {
  const { data: allowed_type_list = [], isFetching } = useGetReportTypesQuery();
  const fields: FormFieldType[] = [
    { type: FormFieldTypesAllowed.Textfield, label: "Name", id: "name", required: "Field is required" },
    { type: FormFieldTypesAllowed.Textfield, label: "Description", id: "description", required: "Field is required" },
    {
      type: FormFieldTypesAllowed.Dropdown,
      label: "Type(s)",
      id: "report_types",
      multiple: true,
      options: allowed_type_list,
      loading: isFetching,
      required: "Field is required",
    },
  ];
  return (
    <FormGenerator
      defaultValues={defaultValues}
      formFields={fields}
      handleFormSubmit={handleSubmit}
      className="admin-panel_generic-form flex gap-4 items-center flex-wrap p-2"
      loading={loading}
    />
  );
};

export default ScheduledReportsTemplatesForm;
